import {Injectable} from '@angular/core';
import {PHONE_MASK} from "../config/country_phone_mask";
import {COUNTRIES_SHORT} from "../config/countries.config";

@Injectable({
    providedIn: 'root'
})
export class PhoneMaskService {
    PHONE_MASK_CONFIG = PHONE_MASK;

    constructor() {
    }

    setPhoneMask() {
        return this.PHONE_MASK_CONFIG[COUNTRIES_SHORT.usa];
    }

}
